import React from "react";
import styled from "styled-components";

interface DividerWithTextProps {
  text: string;
}

const DividerContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 1rem 0;
`;

const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  border-bottom: 1px solid var(--sumi-dark-blue);
`;

const DividerText = styled.span`
  margin: 0 1rem;
`;

const DividerWithText: React.FC<DividerWithTextProps> = ({ text }) => {
  return (
    <DividerContainer className="divider-with-text">
      <DividerLine className="divider-line" />
      <DividerText className="divider-text">{text}</DividerText>
      <DividerLine className="divider-line" />
    </DividerContainer>
  );
};

export default DividerWithText;
